<template>
  <span class="icons-list">
    <span
      :data-comment-count="kr.commentCount"
      class="comment-badge-icon pointer"
      :id="'comment-badge-' + kr.id"
      @click.stop="$emit('comment')"
      v-if="showCommentBadge"
      ><i></i>
      <span class="comment-count" v-if="kr.commentCount > 0">{{ kr.commentCount }}</span>
    </span>
    <action-tooltip
      :target="'comment-badge-' + kr.id"
      text="Comment"
      :actions="showKeyboardHints ? ['c'] : []"
      v-if="showCommentBadge"
    />
    <span :id="'kr-edit-' + kr.id" class="edit-icon pointer" @click.stop="$emit('edit')"
      ><i></i
    ></span>
    <action-tooltip
      :target="'kr-edit-' + kr.id"
      text="Edit"
      :actions="showKeyboardHints ? ['e'] : []"
    />
    <span
      :id="'kr-expander-' + kr.id"
      class="expander-icon pointer"
      @click.stop="$emit('open', $event)"
      v-if="showDetailsPageNavigator"
      ><i></i
    ></span>
    <action-tooltip
      :target="'kr-expander-' + kr.id"
      text="Open"
      :actions="showKeyboardHints ? ['Shift', rightKey] : []"
      v-if="showDetailsPageNavigator"
    />
  </span>
</template>

<script>
import ActionTooltip from '@/components/ActionTooltip.vue'
import prettifyKey from '@/utils/prettifyKey'

/**
 * This shows the list of icons for edit/comment/open KR page
 */
export default {
  name: 'KrActionsIconList',
  props: ['showDetailsPageNavigator', 'showCommentBadge', 'kr', 'showKeyboardHints'],
  components: { ActionTooltip },
  data() {
    return {
      rightKey: prettifyKey('<right>')[0]
    }
  },
  computed: {},
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped>
.icons-list {
  display: flex;
  align-items: flex-start;
  align-self: baseline;
  flex-wrap: nowrap;
  margin-top: 4px;
  margin-left: 8px;
}

.icons-list > :not(:first-child) {
  margin-left: 2px;
}

.expander-icon,
.edit-icon {
  opacity: 0;
  transition: opacity 200ms ease-out;
}

.comment-count {
  margin-left: 2px;
}

.comment-badge-icon[data-comment-count='0'] {
  opacity: 0;
}
</style>
